module.exports = __webpack_public_path__ + "img/case2-2.55007088.jpg";